export const PURCHASE_ORDER_DIVISION_PERMISSION = {
  VIEW: 'PURCHASE_ORDER_DIVISION_VIEW',
  ADD: 'PURCHASE_ORDER_DIVISION_ADD',
  EDIT: 'PURCHASE_ORDER_DIVISION_EDIT',
  DEL: 'PURCHASE_ORDER_DIVISION_DEL',
  REVIEW: 'PURCHASE_ORDER_DIVISION_REVIEW',
  ADD_NEW_REVIEW: 'PURCHASE_ORDER_DIVISION_ADD_NEW_REVIEW',
  ADD_USER_REVIEW: 'PURCHASE_ORDER_DIVISION_ADD_USER_REVIEW',
};

export const DIVISION_TYPE_OPTIONS = [
  {
    value: 0,
    label: 'Giao thẳng về nhà thuốc',
    shortLabel: 'Giao thẳng nhà thuốc',
    description:
      'Dùng khi nhà cung cấp giao trực tiếp về kho nhà thuốc. Chỉ nên gom các đơn mua cùng một nhà cung cấp.',
    accountingDescription:
      'Phiếu này đại diện cho việc nhà cung cấp giao trực tiếp về kho nhà thuốc. Không phát sinh bước nhập kho tổng rồi chia nội bộ.',
    sourceFieldLabel: 'Đơn mua nguồn',
    stockFieldLabel: 'Không dùng kho tổng',
    storeSectionTitle: 'Nhà thuốc nhận hàng trực tiếp',
    productSectionTitle: 'Tổng hợp sản phẩm giao thẳng',
  },
  {
    value: 1,
    label: 'Chia từ kho tổng',
    shortLabel: 'Chia từ kho tổng',
    description:
      'Chia hàng từ kho tổng về các kho bệnh viện theo đơn mua nguồn. Hệ thống tạo phiếu nhập và hóa đơn nháp cho từng kho nhận, không tạo phiếu xuất kho.',
    accountingDescription:
      'Phiếu này là chứng từ điều phối nội bộ từ kho tổng về bệnh viện. Phiếu nhập tại bệnh viện là nhập điều chuyển, không gắn lại nhà cung cấp.',
    sourceFieldLabel: 'Đơn mua nguồn',
    stockFieldLabel: 'Không dùng kho nguồn',
    storeSectionTitle: 'Nhà thuốc nhận hàng',
    productSectionTitle: 'Sản phẩm trên đơn mua',
  },
  {
    value: 2,
    label: 'Chia hàng đơn đặt trước qua kho tổng',
    shortLabel: 'Đơn đặt trước qua kho tổng',
    description:
      'Dùng cho hàng đơn đặt trước gom về kho tổng rồi phân bổ tiếp cho bệnh viện theo đơn đặt trước.',
    accountingDescription:
      'Phiếu này là chứng từ điều phối nội bộ từ kho tổng về bệnh viện. Phiếu nhập tại bệnh viện là nhập điều chuyển, không gắn lại nhà cung cấp.',
    sourceFieldLabel: 'Đơn hàng nguồn',
    stockFieldLabel: 'Kho tổng đơn đặt trước',
    storeSectionTitle: 'Bệnh viện nhận theo đơn đặt trước',
    productSectionTitle: 'Sản phẩm đơn đặt trước chờ phân bổ',
  },
];

const DIVISION_TYPE_MAP = DIVISION_TYPE_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

export const getDivisionTypeConfig = (value) => DIVISION_TYPE_MAP[Number(value)] || DIVISION_TYPE_OPTIONS[0];

export const HIS_PRODUCT_MAPPING_HINT =
  'Phiếu chia luôn giữ mã sản phẩm Portal làm mã mua tập trung. Khi bệnh viện đích nhận hàng, mã thuốc HIS, đơn vị tính, số đăng ký và yêu cầu lô/hạn phải được tra lại theo business_id của viện đích. Nếu chưa có mapping hoặc mapping xung đột, cần xử lý tại màn Map dữ liệu HIS trước khi đồng bộ nhập vào HIS; tuyệt đối không dùng mã HIS của viện nguồn cho viện nhận.';

export const getDivisionTypeLabel = (value, options = {}) => {
  const { short = false } = options;
  const config = getDivisionTypeConfig(value);
  return short ? config.shortLabel : config.label;
};

export const reviewTypeOptions = [
  {
    label: 'Chưa duyệt',
    colorLabel: 'bw_black',
    className: '',
    icon: 'fi-rr-minus',
    value: null,
  },
  {
    label: 'Đã duyệt',
    colorLabel: 'bw_green',
    className: 'bw_agree',
    icon: 'fi-rr-check',
    value: 1,
  },
  {
    label: 'Không duyệt',
    colorLabel: 'bw_red',
    className: 'bw_non_agree',
    icon: 'fi-rr-minus',
    value: 0,
  },
];
